import * as React from "react";
import './FormSelect.css'
import FormButton from "../FormButton/FormButton";

interface IProps {
    options: any[] | undefined;
    selectedOption: boolean | undefined;
    isDisabled?: boolean;
    propName?: string
}

export default class FormSelect  extends React.Component<
    IProps
    > {
    public renderButtons = () => {
        const {options, selectedOption, isDisabled, propName} = this.props;
        if(!options) {
            return;
        }
        return (
            <>
                <div className="btn-container">
                    <FormButton btnText={options[0].text}
                                click={isDisabled? null: options[0].cta.bind(this, {propName, answer: true}) }
                                classes={'blank' + ( selectedOption === true? " selected": "")}/></div>
                <div className="btn-container">
                    <FormButton btnText={options[1].text}
                                click={isDisabled? null : options[1].cta.bind(this, {propName, answer: false})}
                                classes={'blank' + ( selectedOption === false? " selected": "")}/></div>
            </>
        );
    };

    public render() {
        return (
            <div className="select-container">
                {this.renderButtons()}
            </div>
        );
    }


}




// WEBPACK FOOTER //
// ./src/components/FormSelect/FormSelect.tsx